'use client';

import { useCheckAppVersion } from '@/hooks/use-check-app-version';


/**
 * Kiểm tra version của app rồi đá nó ra
 * @returns 
 */
export const CheckingVersion = () => {
    useCheckAppVersion();

    return <></>;
};
